import React, { useEffect } from "react";
import AdminNotificationsShow from "../../components/Notifications/AdminNotificationsShow";
import AdminNotificationsCreate from "../../components/Notifications/AdminNotificationsCreate";
import { useDispatch, useSelector } from "react-redux";
import { fetchSchoolsForAdmin } from "../../actions/schoolActions";
import { fetchAvailableProgramLicenses } from "../../actions/programLicenseActions";
import Pacmanloader from "../../components/Pacmanloader/Pacmanloader";

export default function NotificationsAdministration() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchSchoolsForAdmin());
    dispatch(fetchAvailableProgramLicenses());
  }, [dispatch]);

  const licenseData = useSelector((state) => state.programLicenseReducer);
  const schoolData = useSelector((state) => state.schoolReducer);
  if (schoolData.loading || licenseData.loading) {
    return <Pacmanloader />;
  }

  return (
    <>
      <AdminNotificationsCreate
        schoolData={schoolData}
        licenseData={licenseData}
      />
      <AdminNotificationsShow
        schoolData={schoolData}
        licenseData={licenseData}
      />
    </>
  );
}
